import styled from "styled-components"
import { getColor, getPosition, below } from "./utils"

export const Display = styled.h1`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: 45px;
  font-weight: 600;
  ${below.md`
    font-size: 40px;
  `};
`

export const Header = styled.h2`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: 33px;
  ${below.md`
    font-size: 31px;
  `};
`

export const Title = styled.h3`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: ${({ font }) => font || `28px`};
  margin: 10px 0;
  ${below.md`
    font-size: 24px;
  `};
`

export const Headline = styled.p`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: ${({ font }) => font || `20px`};
  margin: 10px 0;
  ${below.md`
    font-size: 18px;
  `};
`

export const Body = styled.p`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: ${({ font }) => font || `1rem`};
`

export const Markdown = styled.div`
  text-align: ${props => getPosition(props)};
  color: ${props => getColor(props)};
  font-size: ${({ font }) => font || `1rem`};
`
